/** Composite prompt input — textarea + saved prompt selector (FR-PRM-05). */

import { Autocomplete, TextField, Box } from "@mui/material";
import { usePrompts } from "@/hooks/usePrompts";

interface Props {
  value: string;
  onChange: (value: string) => void;
  label?: string;
  helperText?: string;
}

export default function PromptInput({ value, onChange, label = "Prompt", helperText }: Props) {
  const { data } = usePrompts();

  const personal = (data?.personalPrompts ?? []).map((p) => ({ ...p, group: "My Prompts" }));
  const templates = (data?.templatePrompts ?? []).map((p) => ({ ...p, group: "Templates" }));
  const options = [...templates, ...personal];

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      <Autocomplete
        options={options}
        groupBy={(o) => o.group}
        getOptionLabel={(o) => o.title}
        onChange={(_, selected) => {
          if (selected) onChange(selected.content);
        }}
        renderInput={(params) => (
          <TextField {...params} label="Load saved prompt" size="small" />
        )}
        size="small"
      />
      <TextField
        label={label}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        helperText={helperText}
        multiline
        rows={6}
        fullWidth
      />
    </Box>
  );
}
